module.exports = __webpack_public_path__ + "245ab63be63cdfee5b1c133583604728.svg";